import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import ReviewModal from "./ReviewModal";
import { useAuth } from "../../context/AuthContext";
import RateReviewIcon from "@mui/icons-material/RateReview";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
const Review = ({
  id,
  rating,
  name,
  title,
  review,
  imgs,
  uid,
  productId,
  link,
  productName,
  created,
  admin,
}) => {
  const { currentUser } = useAuth();
  console.log("created", created);
  const { t, i18n } = useTranslation();

  // console.log({ imgs });

  let query2 = useQuery();
  let edit_url;
  // console.log("************* productId", productId);

  if (query2.get("name")) {
    let productName = query2.get("name");
    let link = query2.get("link");
    let productIdFromURL = query2.get("productId");
    edit_url = `/dashboard-edit-review?productId=${productIdFromURL}&name=${productName}&link=${link}&id=${id}`;
    // console.log(edit_url);
  } else {
    edit_url = `/dashboard-edit-review?productId=${productId}&name=${productName}&link=${link}&id=${id}`;
    // console.log(edit_url);
  }

  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingBottom: "20px",
        paddingTop: "20px",
      }}
    >
      <Grid item md={12} sx={{ display: "flex", alignItems: "center" }}>
        <Rating
          name="text-feedback"
          value={rating}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
          sx={{ paddingRight: "5px", position: "relative", top: "-3px" }}
        />
        <Box sx={{ color: "lightgray" }}>/</Box>
        <div style={{ fontSize: "15px", color: "gray", paddingLeft: "5px" }}>
          <img src="./img/user4.png" width="15" height="15" />{" "}
          {name.substring(0, 4) + "****"}{" "}
        </div>
        <Box>{created}</Box>
        <Box sx={{ color: "lightgray" }}>/</Box>
        <Typography sx={{ paddingLeft: "5px", fontWeight: "bold" }}>
          {title?.length > 60 ? title.substr(0, 60 - 1) + "..." : title}
        </Typography>
      </Grid>

      <Grid item md={12}>
        <Typography sx={{ paddingTop: "12px" }}>
          {review?.length > 120 ? review.substr(0, 120 - 1) + "..." : review}
        </Typography>
        <Box sx={{ pt: 1 }}>
          <ReviewModal imgs={imgs} title={title} review={review} />
        </Box>
      </Grid>
      {uid === currentUser?.uid ? (
        <Grid
          item
          md={12}
          sx={{
            textDecoration: "underline",
            color: "#f3756d",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          <HashLink to={edit_url}>
            <RateReviewIcon sx={{ fontSize: "14px", mr: 1 }} />
            {t("Edit/Delete my review")}
          </HashLink>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Review;
